export default "__VITE_ASSET__2b8e1756__"